import useSWR, { type SWRResponse } from "swr";
import { useApiClient } from "@/hooks/useApiClient";
import {
  type AcquiredRequestsResponse,
  type AcquiredPropertySearch,
} from "../types";
import {
  ACQUIRED_REQUESTS_ENDPOINT,
  getAcquiredRequests,
} from "../api/getAcquiredRequests";
import { notifySearchError } from "../utils/searchError";
import { makeSearchParams } from "../utils/searchState";

export const useAcquiredRequests = (
  search: AcquiredPropertySearch,
  userId: string,
  isSharable: boolean,
  revalidateIfStale = true
): SWRResponse<AcquiredRequestsResponse, Error> => {
  const { apiClient } = useApiClient();
  const params = makeSearchParams(search);
  return useSWR<AcquiredRequestsResponse, Error>(
    userId ? [ACQUIRED_REQUESTS_ENDPOINT, userId, isSharable, params] : null,
    async ([, , , searchParams]: [string, string, boolean, typeof params]) =>
      await getAcquiredRequests(apiClient, searchParams),
    {
      keepPreviousData: false,
      onError: notifySearchError,
      shouldRetryOnError: false,
      revalidateIfStale,
      revalidateOnFocus: true,
    }
  );
};
